import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { OZ, BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import H7 from 'UIComponents/elements/headings/H7';
import UIButton from 'UIComponents/button/UIButton';
import { CompletionStatuses } from '../../constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RecommendationBaseView = ({
  testId,
  title,
  description,
  status,
  action,
  actionButtonText,
  onTrackAction,
  children
}) => {
  const hideRecommendation = status === CompletionStatuses.NOT_APPLICABLE;
  const color = status === CompletionStatuses.COMPLETE ? OZ : BATTLESHIP;
  const showActionLink = action && status === CompletionStatuses.INCOMPLETE;
  if (hideRecommendation) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "m-x-1",
    "data-test-id": testId || 'recommendation-base-view',
    children: [/*#__PURE__*/_jsxs("div", {
      className: "display-flex",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIIconCircle, {
          color: OLAF,
          backgroundColor: color,
          name: "success",
          size: 10,
          padding: 0.1
        })
      }), /*#__PURE__*/_jsx(H7, {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx("div", {
          className: "m-left-2 m-top-1",
          children: title
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "m-bottom-2 m-left-6",
      children: [/*#__PURE__*/_jsx("div", {
        children: description
      }), showActionLink && /*#__PURE__*/_jsx("div", {
        className: "m-y-1",
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: () => {
            if (onTrackAction) {
              onTrackAction();
            }
            action();
          },
          size: "small",
          use: "tertiary",
          children: actionButtonText || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "xray-recommendation-lib.actions.fix"
          })
        })
      })]
    }), children]
  });
};